/**
 * Utility functions for formatting room type descriptions
 */

export function getRoomTypeDescription(
  roomBeds: number,
  roomBedType: string,
): string {
  // Normalize bed type
  const bedType = (roomBedType || '').toLowerCase().trim();

  // Handle invalid or missing bed count
  if (!roomBeds || roomBeds < 1) {
    roomBeds = 1; // Default to 1 like database
  }

  // Format bed type for display
  const getBedTypeLabel = (type: string): string => {
    if (type.includes('queen')) return 'Queen Bed';
    if (type.includes('king')) return 'King Bed';
    if (type.includes('twin')) return 'Twin Beds';
    if (type.includes('double')) return 'Double Bed';
    if (type.includes('single')) return 'Single Bed';
    return ''; // No bed type specified
  };

  const bedTypeLabel = getBedTypeLabel(bedType);

  if (roomBeds === 1) {
    return bedTypeLabel ? `Single Room (${bedTypeLabel})` : 'Single Room';
  }

  if (roomBeds === 2) {
    return bedTypeLabel ? `Double Room (${bedTypeLabel})` : 'Double Room';
  }

  // For 3+ beds (rare but possible)
  // Don't assume "Suite" - be accurate
  if (bedTypeLabel) {
    return `${roomBeds}-Bed Room (${bedTypeLabel})`;
  }
  return `${roomBeds}-Bed Room`;
}

export function formatRoomQuantity(
  rooms: number,
  roomBeds: number,
  roomBedType: string,
): string {
  const roomType = getRoomTypeDescription(roomBeds, roomBedType);
  return `${rooms}x ${roomType}`;
}

/**
 * Format room description for guest list (e.g., "Double Room · 2 Guests")
 */
export function formatRoomGuestDescription(
  roomBeds: number,
  roomBedType: string,
  guestCount: number,
): string {
  const roomType = getRoomTypeDescription(roomBeds, roomBedType);
  const guestText = guestCount === 1 ? '1 Guest' : `${guestCount} Guests`;
  return `${roomType} · ${guestText}`;
}
